import { useEffect } from 'react'
import { connect } from 'react-redux'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import { createSession, setLoading, showAlert } from '../../actions'
import LoadingSpinner from '../general/LoadingSpinner'
import { directSsoReturnUrl } from '../../util/recordingNavigation'

const SSoSignInPage = ({ createSession, currentLocation, setLoading }) => {
  const { sso_id, sso_token } = useParams()
  const history = useHistory()
  const location = useLocation()

  // wait for data to load, then create session using SSO ID/token from params
  useEffect(() => {
    if (sso_id && sso_token) {
      localStorage.setItem('authToken', sso_token)
      history.push(directSsoReturnUrl(location.search))
      window.location.reload()
    }
  }, [sso_id, sso_token, location.search, history])

  return <LoadingSpinner />
}

const mapStateToProps = state => {
  return {
    currentLocation: state.storeViews.current
  }
}

export default connect(mapStateToProps, {
  createSession,
  showAlert,
  setLoading
})(SSoSignInPage)
export { SSoSignInPage }
